let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fVd3N")).then(() => parcelRequire('6BTY4'));